import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";
import { ICertificationDeleteRequest, ICertificationFile, ICertificationGenerateRequest } from "./schoolCertificationModel";

const httpService = new HTTPService();
const fileUpload = (files: File[]): Promise<IHTTPResponse<IAPIResponse<any>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.HallTicketFileUpload
        }`;
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file) });

  

    return httpService.fileUpload(url, formData);
};

const getFiles = (): Promise<IHTTPResponse<IAPIResponse<ICertificationFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.HallTicketList}`;

    return httpService.get(url);
}

const deleteFile = (deleteFileRequest: ICertificationDeleteRequest): Promise<IHTTPResponse<IAPIResponse<ICertificationFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.HallTicketFileDelete}`;

    return httpService.post(url, deleteFileRequest);
}

const generateHallTicketFile = (certificateGenerateRequest: ICertificationGenerateRequest): Promise<IHTTPResponse<IAPIResponse<ICertificationFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.HallTicketGenerate}`;

    return httpService.post(url, certificateGenerateRequest);
}

const getStudentFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.HallTicketDownloadStudentFile}/${fileId}`;

    return url;
}

const getHallTicketFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.HallTicketDownloadHallTicketFile}/${fileId}`;

    return url;
}

const HallTicketService = {
    fileUpload,
    getFiles,
    deleteFile,
    getStudentFileDownloadUrl,
    getHallTicketFileDownloadUrl,
    generateHallTicketFile
};

export default HallTicketService;